module.exports = __webpack_public_path__ + "img/xnyyjn.9d814b3.png";